<template>
    <tq-image v-if="p_ud_avatar_c.cuda_avatarImage_b && p_ud_avatar_c.cuda_imgFile_c.fi_url_s"
              :pb_default-img_r="ass_img_avatar3_b"
              :pb_src_r="p_ud_avatar_c.cuda_imgFile_c.fi_url_s"/>

    <svg v-else viewBox="0 0 280 280" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

        <!--<rect x="0" y="0" width="264" height="264" fill="none"/>-->
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-815.000000, -1100.000000)" >
                <g transform="translate(825.000000, 1100.000000)">

                    <g stroke-width="1" fill-rule="evenodd" >

                        <!-- body -->
                        <g  transform="translate(32.000000, 36.000000)">
                            <defs>
                                <circle cx="120" cy="120" r="120"/>
                                <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" />
                                <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z"
                                      :id="m_currentId_fs('react-path-3')"/>
                            </defs>

                            <mask :id="m_currentId_fs('react-mask-6')" fill="white">
                                <use :xlink:href="m_currentId_fs('#react-path-3')"/>
                            </mask>
                            <use fill="#D0C6AC" :xlink:href="m_currentId_fs('#react-path-3')"/>

                            <g :mask="m_currentUrlId_fs('react-mask-6')" fill="#FFDBB4">
                                <g transform="translate(0.000000, 0.000000)">
                                    <rect x="0" y="0" width="264" height="280"/>
                                </g>
                            </g>
                            <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" fill-opacity="0.100000001" fill="#000000"
                                  :mask="m_currentUrlId_fs('react-mask-6')"/>
                        </g>

                        <!-- clothing -->
                        <g :key="'uda_clothing_e' + p_ud_avatar_c.cuda_clothing_e" v-html="avatar_clothing_xml(p_ud_avatar_c.cuda_clothing_e, p_ud_avatar_c.cuda_clothingColor_s)" class="TQ_Animation_smallBigSmall"></g>

                        <!-- face -->
                        <g transform="translate(76.000000, 82.000000)" fill="#000000">

                            <!-- eyebrow -->
                            <g :key="'uda_eyebrow_e' + p_ud_avatar_c.cuda_eyebrow_e" v-html="avatar_com_eyebrow_xml(p_ud_avatar_c.cuda_eyebrow_e)" class="TQ_animation_fadeIn"></g>

                            <!-- eyes -->
                            <g :key="'uda_eyes_e' + p_ud_avatar_c.cuda_eyes_e" v-html="avatar_com_eyes_xml(p_ud_avatar_c.cuda_eyes_e)" class="TQ_animation_fadeIn"></g>

                            <!-- nose -->
                            <g transform="translate(28.000000, 40.000000)" fill-opacity="0.16">
                                <path d="M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8" />
                            </g>

                            <!-- mouth -->
                            <g :key="'uda_mouth_e' + p_ud_avatar_c.cuda_mouth_e" v-html="avatar_com_mouth_xml(p_ud_avatar_c.cuda_mouth_e)" class="TQ_animation_fadeIn"></g>

                        </g>

                        <!-- top -->
                        <g >

                            <!-- accessories -->
                            <g :key="'uda_accessories_e' + p_ud_avatar_c.cuda_accessories_e" v-html="avatar_accessories_xml(p_ud_avatar_c.cuda_accessories_e)" class="TQ_animation_fadeIn"></g>

                            <!-- top -->
                            <g :key="'uda_top_e' + p_ud_avatar_c.cuda_top_e" v-if="!m_topOnTop_b(p_ud_avatar_c.cuda_top_e)" v-html="avatar_top_xml(p_ud_avatar_c.cuda_top_e, p_ud_avatar_c.cuda_hairColor_s)" class="TQ_animation_fadeIn"></g>

                            <!-- facialHair -->
                            <g :key="'uda_facialHair_e' + p_ud_avatar_c.cuda_facialHair_e" v-html="avatar_facialHair_xml(p_ud_avatar_c.cuda_facialHair_e, p_ud_avatar_c.cuda_hairColor_s)" class="TQ_animation_fadeIn"></g>

                            <!-- top -->
                            <g :key="'uda_top_e' + p_ud_avatar_c.cuda_top_e" v-if="m_topOnTop_b(p_ud_avatar_c.cuda_top_e)" v-html="avatar_top_xml(p_ud_avatar_c.cuda_top_e, p_ud_avatar_c.cuda_hairColor_s)" class="TQ_animation_fadeIn"></g>

                        </g>
                    </g>
                </g>
            </g>
        </g>

    </svg>
</template>

<script>

import {FB_UserData_Avatar} from "../../../functions/src/shareCode/Share_S_Classes";
import {
    avatar_accessories_xml, avatar_clothing_xml,
    avatar_eyebrow_xml, avatar_eyes_xml, avatar_mouth_xml,
    avatar_facialHair_xml,
    avatar_top_xml
} from "@/scripts/S_Avatar";
import {enum_avatar_top_e} from "../../../functions/src/shareCode/Share_S_Enum";
import TqImage from "@/components/basic/TqImage";
import {ass_img_avatar3_b, ass_img_avatar_g, ass_img_avatar_p} from "@/assets/scripts/Ass_Files";

    export default {
        name: "FccAvatar",
        components: {TqImage},
        props:{
            p_ud_avatar_c:{
                type: FB_UserData_Avatar,
                require: true,
            },
        },
        data(){
            return {
                ass_img_avatar3_b : ass_img_avatar3_b,

                avatar_accessories_xml: avatar_accessories_xml,
                avatar_top_xml: avatar_top_xml,
                avatar_facialHair_xml: avatar_facialHair_xml,
                avatar_com_eyebrow_xml: avatar_eyebrow_xml,
                avatar_com_mouth_xml: avatar_mouth_xml,
                avatar_com_eyes_xml: avatar_eyes_xml,
                avatar_clothing_xml: avatar_clothing_xml,
            }
        },
        methods:{
            m_topOnTop_b(top_e){
                switch(top_e){

                    case enum_avatar_top_e.WinterHat1:
                    case enum_avatar_top_e.WinterHat2:
                    case enum_avatar_top_e.WinterHat3:
                    case enum_avatar_top_e.WinterHat4:
                    case enum_avatar_top_e.Hijab:
                    case enum_avatar_top_e.Turban:
                        return true
                    default:
                        return false
                }

            },
            m_currentId_fs(id_s){
                return id_s + "_" + this.$options._parentVnode.key
            },
            m_currentUrlId_fs(id_s){
                return `url(#${this.m_currentId_fs(id_s)})`
            }
        },
    }
</script>

<style scoped lang="scss">

    .animate {
        stroke-dasharray: 1000;
        stroke-dashoffset: 1000;
        animation: dash 5s linear alternate infinite;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }

</style>